import { IResource } from '@rove-team/locale';

export const englishUSA: IResource = {
  layout: {
    siteName: 'State of Democracy',
    home: 'Home',
    overall: 'Overall',
    participation: 'Participation',
    competition: 'Competition',
    representation: 'Representation',
    polarization: 'Polarization',
    about: 'About',
    readTheReport: 'Read The Report',
    media: 'Media',
    takeAction: 'Take Action',
    methodology: 'Methodology',
    stateOfReform: 'State Of Reform',
    data: 'Data',
  },
  criteria: {
    overall: 'Overall',
    participationTitle: 'Participation',
    competitionTitle: 'Competition',
    representationTitle: 'Representation',
    polarizationTitle: 'Polarization',
    participationDescription: 'ParticipationDescription',
    competitionDescription: 'CompetitionDescription',
    representationDescription: 'RepresentationDescription',
    polarizationDescription: 'PolarizationDescription',
    findYourState: 'Find Your State',
    getTheFacts: 'Get the Facts',
    getInvolved: 'Get Involved',
    findYourStateDesc:
      'Click on your state on the map to get details about its score.',
    getTheFactsDesc:
      'Look at the details pages for your state to see where it’s doing well, and where it’s lagging.',
    getInvolvedDesc: 'Volunteer and otherwise be an awesome human being.',
    grade: 'Grade',
    gradeText: 'Hover on a state for details',
  },
  home: {
    title: 'Home',
    grade: 'Grade',
    gradeText: 'Hover on a state for details',
  },
  notFound: {
    title: 'Not Found',
    notFound: '404 Error',
    sorry: 'Sorry',
    excuseText: 'The page you’re looking for doesn’t exist.',
    homeButtonText: 'back to home',
  },
  share: {
    share: 'Share',
    copy: 'Copy',
    copied: 'Copied!',
    embed: 'Embed',
  },
  embedModal: {
    copySnippet: 'Copy Snippet',
    copied: 'Copied!',
    embeddedPreview: 'Embedded Preview',
    close: 'Close',
    downloadImage: 'Download Image',
  },
  aboutUs: {
    title: 'About Us',
  },
  readTheReport: {
    title: 'Read The Report',
    pageTitle: 'Read The Report',
  },
  media: {
    title: 'Media',
    pageTitle: 'Media',
  },
  methodology: {
    title: 'Methodology',
    pageTitle: 'Methodology',
  },
  takeAction: {
    title: 'Take Action',
    pageTitle: 'Take Action',
  },
  stateSpecific: {
    alabama: 'Alabama',
    alaska: 'Alaska',
  },
  similarState: {
    similarState: 'Similar State',
  },
  improveBox: {
    callToAction: 'Call To Action',
  },
  detailsContainer: {
    title: 'Details',
    component: 'Component',
    description: 'Description',
    electionCycles: 'Last 5 Election Cycles',
  },
  detailItems: {
    average: 'US Ave',
  },
  competitionDetails: {
    overallTitle: 'Overall HVD',
    componentTitle: 'Component of HVD',
  },
  participationDetails: {
    generalElections: 'General Elections',
    primaryElections: 'Primary Elections',
    usAverage: 'US Average',
  },
  demographicParity: {
    calculatingParity: 'Calculating Demographic Parity',
    parity: 'Parity',
    population: '2020 Values',
    legislature: 'Legislature',
  },
  criteriaGrade: {
    avg: 'Avg',
    rawScore: 'Raw Score',
  },
  criteriaDetailsPercent: {
    usAve: 'US Ave',
  },
  whatToDoHome: {
    whatToDo: 'What to do next',
    moreInfo: 'More Info',
  },
  whatToDoOverall: {
    whatToDo: 'What to do next',
    getInvolved: 'Get Involved',
    getInvolvedDesc: 'Volunteer and otherwise be an awesome human being.',
    moreInfo: 'More Info',
  },
  overallMapTemplate: {
    title: 'Overall',
  },
  criteriaMapTemplate: {
    competitionTitle: 'Competition',
    polarizationTitle: 'Polarization',
    representationTitle: 'Representation',
    participationTitle: 'Participation',
    competitionDescription: 'Competition Description',
    polarizationDescription: 'Polarization Description',
    representationDescription: 'Representation Description',
    participationDescription: 'Participation Description',
  },
  sorMapTemplate: {
    voteAtHomeTitle: 'Vote at Home',
    rcvTitle: 'Ranked Choice Voting',
    ircTitle: 'Independent Redistricting',
    primariesTitle: 'Open Primaries',
    voteAtHomeDescription: 'Vote at Home Description',
    rcvDescription: 'Ranked Choice Voting Description',
    ircDescription: 'Independent Description',
    primariesDescription: 'Open Primaries Description',
  },
  stateHeader: {
    about: 'About',
    media: 'Media',
    takeAction: 'Take Action',
  },
  stateOverallTemplate: {
    title: 'Overall',
    scoreTitle: 'Overall Score',
    scoreDescription: 'Score Description',
    componentScore: 'Component Score',
    component: 'Component',
    description: 'Description',
    last5ElectionCycles: 'Last 5 Election Cycles',
    moreInfo: 'More info',
    participation: 'Participation',
    competition: 'Competition',
    representation: 'Representation',
    polarization: 'Polarization',
    volunteer: 'Volunteer and otherwise be an awesome human being',
    firstScoreDescription: 'State Overall Description',
    secondScoreDescription: '',
  },
  stateParticipationTemplate: {
    title: 'Participation',
    scoreTitle: 'Participation Score',
    improveParticipation: 'How to improve participation?',
    turnOut: 'Turnouts',
    generalElection: 'General Election',
    primaryElection: 'Primary Election',
    usAverage: 'US Average',
    firstScoreDescription: 'State Participation Description',
    secondScoreDescription: '',
  },
  stateRepresentationTemplate: {
    title: 'Representation',
    scoreTitle: 'Representation Score',
    improveRepresentation: 'How to improve representation?',
    sexParity: 'Gender Parity',
    raceParity: 'Race Parity',
    female: 'Female',
    nonWhite: 'None White',
    firstScoreDescription: 'State Representation Description',
    secondScoreDescription: 'Second State Representation Description',
  },
  statePolarizationTemplate: {
    title: 'Polarization',
    scoreTitle: 'Polarization Score',
    polarizationDesc: 'Polarization Description',
    improvePolarization: 'How to improve polarization',
    house: 'House',
    senate: 'Senate',
    firstScoreDescription: 'State Polarization Description',
    secondScoreDescription: 'Second State Polarization Description',
  },
  stateCompetitionTemplate: {
    title: 'Competition',
    scoreTitle: 'Competition Score',
    improveCompetition: 'Improve Competition',
    hvdComponent: 'Component of HVD',
    hvdScore: 'HVD Score',
    winnersShare: "Winner's Vote Share",
    marginVictory: 'Margin of Victory',
    unContested: 'Contested Races',
    unCompetitive: 'Safe Seats',
    firstScoreDescription: 'State Competition Description',
    secondScoreDescription: 'Second State Competition Description',
  },
  sorLayout: {
    siteName: 'State of Reform',
    home: 'Home',
    voteAtHome: 'Vote At Home',
    rankedChoiceVoting: 'Ranked Choice Voting',
    openPrimaries: 'Open Primaries',
    independentRedistricting: 'Independent Redistricting',
    about: 'About',
    contact: 'Contact',
    privacyPolicy: 'Privacy Policy',
  },
  whatSORMeans: {
    whatSORMeansTitle: 'What Reform Means',
  },
  stateOfReform: {
    mapDescription:
      'An overall grade for each state, when compared to all other states in each of the five areas.',
    // voteAtHome: 'Vote at Home',
    // rcv: 'Ranked Choice Voting',
    // primaries: 'Open Primaries',
    // irc: 'Independent Redistricting',
    // mapDescription:
    //   'An overall grade for each state, when compared to all other states in each of the five areas.',
    // voteAtHomeLowTitle: '[tbd definition]',
    // voteAtHomeLowDescription:
    //   'Without primary reform, primaries are “closed” which means.... and causes these problems....',
    // voteAtHomeMediumTitle: 'Permanent Absentee Voter List',
    // voteAtHomeMediumDescription: 'Open primaries achieve these goals...',
    // voteAtHomeHighTitle: 'Full Vote at Home',
    // voteAtHomeHighDescription:
    //   'Non-partisan primaries go even further and do this.',
    // rcvLowTitle: 'No Statewide RCV Use',
    // rcvLowDescription:
    //   'Without primary reform, primaries are “closed” which means.... and causes these problems....',
    // rcvMediumTitle: 'RCV used Statewide',
    // rcvMediumDescription: 'Open primaries achieve these goals...',
    // rcvHighTitle: 'RCV used for Congress',
    // rcvHighDescription: 'Non-partisan primaries go even further and do this.',
    // ircLowTitle: 'No Commissions',
    // ircLowDescription:
    //   'Without primary reform, primaries are “closed” which means.... and causes these problems....',
    // ircMediumTitle: 'Non-Citizen Commission',
    // ircMediumDescription: 'Open primaries achieve these goals...',
    // ircHighTitle: 'Citizen Commission',
    // ircHighDescription: 'Non-partisan primaries go even further and do this.',
    // primariesLowTitle: 'Closed Primaries',
    // primariesLowDescription:
    //   'Without primary reform, primaries are “closed” which means.... and causes these problems....',
    // primariesMediumTitle: 'Open Primaries',
    // primariesMediumDescription: 'Open primaries achieve these goals...',
    // primariesHighTitle: 'Nonpartisan Primaries',
    // primariesHighDescription:
    //   'Non-partisan primaries go even further and do this.',
  },
  stateOfReformHeader: {
    stateOfDemocracy: 'State of Democracy',
    about: 'About',
  },
  stateOfReformFooter: {
    stateOfDemocracy: 'State of Democracy',
  },
};
